module.exports = __webpack_public_path__ + "static/media/linkedinsso.74222d6f.svg";